import { render, staticRenderFns } from "./createOverview.vue?vue&type=template&id=3d4b1f51&scoped=true"
import script from "./createOverview.vue?vue&type=script&lang=js"
export * from "./createOverview.vue?vue&type=script&lang=js"
import style0 from "./createOverview.vue?vue&type=style&index=0&id=3d4b1f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b1f51",
  null
  
)

export default component.exports